<script>
	import InputWrapper from '../InputWrapper.svelte';

	let {
		name,
		value = $bindable(),
		element = $bindable(),
		class: className = '',
		required = false,
		disabled = false,
		error = null,
		label = null,
		onchange = null,
		...props
	} = $props();

	function autoResize() {
		element.style.height = 'auto'; // Reset height first
		element.style.height = element.scrollHeight + 10 + 'px'; // add a little for scrollbar removal
	}
</script>

<InputWrapper {label} {error} class={className}>
	<textarea
		bind:this={element}
		bind:value
		class={[
			'border-indow-grey-light w-full content-start rounded-md',
			{ 'bg-indow-grey-light cursor-not-allowed': disabled },
			{ 'border-indow-red': error },
		]}
		aria-invalid={error ? true : undefined}
		{name}
		oninput={autoResize}
		{required}
		{disabled}
		{onchange}
		{...props}
	></textarea>
</InputWrapper>
